<template>
  <drop-down class="shop-sort-dropdown"
    :available-options="options"
    :selected-item="sortValue"
    @on-select="changeSortBy($event)"
    show-right>
    Sort by <b>{{sortByLabel}}</b>
  </drop-down>
</template>

<script lang="ts">
import DropDown from "~/components/UI/DropDown.vue";
import { useSearchStore } from "~/stores/searchStore";

export default {
  setup () {
    return {
      searchStore: useSearchStore(),
    };
  },
  components: {
    DropDown,
  },
  computed: {
    sortValue () {
      return this.searchStore.meta.userOrderBy ?? this.searchStore.defaultOrderBy;
    },
    sortByLabel () {
      const selectedOption = this.options.find((option) => option.id === this.sortValue);

      return selectedOption
        ? selectedOption.label
        : this.sortValue;
    },
    options () {
      let options = [
        {
          id: 'date',
          label: 'Latest',
        }, {
          id: 'popularity',
          label: 'Popularity',
        }, {
          id: 'price',
          label: 'Price: low to high',
        }, {
          id: 'price-desc',
          label: 'Price: high to low',
        },
      ];

      if (this.searchStore.filters.freeText) {
        options = [
          {
            id: 'relevance',
            label: 'Relevance',
          },
          ...options,
        ]
      }

      return options;
    },
  },
  methods: {
    changeSortBy (changeTo: string) {
      this.searchStore.meta.userOrderBy = changeTo;
      this.$emit('filter-change-event')
    },
  },
};
</script>

<style lang="scss">
  .shop-sort-dropdown ul li button {
    white-space: nowrap;
  }
</style>